<template>
	<div class="ao-checkboxes-collapse">
		<div v-if="inputTitle"
			class="ao-h4 mb-1">{{inputTitle}}</div>
		<div class="d-flex align-center ao-text-secondary-color-700"
			style="cursor: pointer;"
			@click="toggleShowContent">
			<ao-icon iconName="arrowBold"
				size="small"
				class="ao-checkboxes-collapse-icon mr-1"
				:class="{'rotated' : !showContent }"  />
			<ao-checkbox
				color="secondary"
				:model-value="modelMainItem"
				:partially="isPartially"
				@update:modelValue="updateMainItem(mainItem)"
			>
				<span>{{getTitle(mainItem)}}</span>
			</ao-checkbox>
		</div>
		<div ref="colapse"
			class="ao-checkboxes-collapse-content ml-5">
			<ao-checkbox v-for="item in items"
				:key="getKey(item)"
				class="ml-4"
				color="secondary"
				:model-value="modelValue.includes(getKey(item))"
				@update:modelValue="update(item)"
			>
				<span>{{getTitle(item)}}</span>
			</ao-checkbox>
		</div>
	</div>
</template>

<script>
export default {
	name: 'AoCheckboxesCollapse',
	components: {},
	props: {
		modelValue: {
			type: Array,
		},
        modelMainItem:{
            type: Boolean,
        },
		mainItem:{
			type: Object,
		},
		items: {
			type: Array,
		},
		itemTitle: {
			type: String,
		},
		itemValue: {
			type: String,
		},
		returnObject: Boolean,
		inputTitle:{
			type: String,
			default: null,
		},
	},

	emits: ['update:modelValue', 'update:modelMainItem'],

	data: () => ({
		showContent:false
	}),
	computed:{
		filteredItems(){
			if(!this.query){
				return this.items
			}
			return this.items.filter(item=>{
					if(item[this.itemTitle]){
					return item[this.itemTitle].includes(this.query)
					}
					return item.includes(this.query)
				}
			)
		},
		isPartially(){
			return this.modelValue.length>0 && this.modelValue.length!==this.items.length
		}
	},
	created() { },
	mounted(){
		this.$refs.colapse.style.maxHeight='0px'
	},
	methods: {
		handleInput() {
		},
		update(item){
			if(this.returnObject){
			this.$emit('update:modelValue', item)
			}else{
			this.$emit('update:modelValue', this.getKey(item))
			}
		},
		updateMainItem(item){
			this.$emit('update:modelMainItem', item)
		},
		getKey(item){
			return item[this.itemValue] ? item[this.itemValue] : item
		},
		getTitle(item){
			return item[this.itemTitle] ? item[this.itemTitle] : item
		},
		toggleShowContent(){
			this.showContent=!this.showContent;
			if(this.showContent){
				this.$refs.colapse.style.maxHeight=`${this.$refs.colapse.scrollHeight}px`;
			}else{
				this.$refs.colapse.style.maxHeight='0px';
			}
		},
		
	}
}
</script>

<style lang="scss">
.ao-checkboxes-collapse{
	width:100%;
	.ao-checkboxes-collapse-icon{
	transition: 0.3s;
	&.rotated{
	transform: rotate(-90deg)
	}
}
&-content{
	overflow: hidden;
	transition: max-height 0.3s ease-out;
}
}
</style>
